import { useTranslation } from 'react-i18next';

import { Card } from 'src/components/ui/card';
import { ForecastPaginatedControl } from 'src/features/forecastPaginated/forecastPaginatedControls/ForecastPaginatedControl';
import { useForecastPaginatedControls } from 'src/features/forecastPaginated/hooks/useForecastPaginatedControls';
import type { ForecastDataPoint } from 'src/types/domain/ForecastDataPoint';

type ForecastPaginatedControlsProps = {
  sessionId: string;
  sku: string;
  data: ForecastDataPoint[];
};

export function ForecastPaginatedControls({
  sessionId,
  sku,
  data,
}: ForecastPaginatedControlsProps) {
  const { t } = useTranslation('forecast');
  const {
    trendAdjustment,
    setTrendAdjustment,
    proposalAdjustment,
    setProposalAdjustment,
    handleDecrease,
    handleIncrease,
    handleTrendUp,
    handleTrendDown,
  } = useForecastPaginatedControls(sessionId, sku, data);

  return (
    <Card className='mt-4 flex h-44 w-full flex-col gap-y-4 p-4 lg:mt-0 lg:w-1/3'>
      <ForecastPaginatedControl
        handleDecrease={handleDecrease}
        handleIncrease={handleIncrease}
        label={t('Height')}
        setValue={setProposalAdjustment}
        value={proposalAdjustment}
      />
      <ForecastPaginatedControl
        handleDecrease={handleTrendDown}
        handleIncrease={handleTrendUp}
        label={t('Trend')}
        setValue={setTrendAdjustment}
        value={trendAdjustment}
      />
    </Card>
  );
}
